async function getAllFavBooks(){
  let favBook = await favSvc.retrieveFavoriteBookByEmailYearEduSubject({
    email: sessionStorage.getItem("userEmail"),
    edu: sessionStorage.getItem("edu"),
    year: sessionStorage.getItem("year"),
    subject: sessionStorage.getItem("subject"),
  });
  favBook = favBook.data;
  const sessionEdu = sessionStorage.getItem("edu");
  const sessionYear = sessionStorage.getItem("year");
  const sessionSubject = sessionStorage.getItem("subject");

  // 同一個 materialId 只顯示一次
  const distinctFavBook = Object.values(favBook.reduce((result, item) => {
    if (!result[item.materialId]) {
      result[item.materialId] = item;
    }
    return result;
  }, {}));


  // clear html
  $(".book_select").html("");
  let bookHtml = ``;
  distinctFavBook.forEach((book) => {
    bookHtml = bookHtml + `
              <div class="book_item">
                <div class="bookimg">
                    <a href="./refer_favorite_detail.html?year=${sessionYear}&edu=${sessionEdu}&subject=${sessionSubject}&bookId=${book.material[0]._id}">
                        <img src="${book.material[0].coverImgUrl}" alt="${book.material[0].name}" width="100%" data-id="${book.material[0]._id}" data-no="${book.material[0].materialNo}">
                    </a>
                </div>
                <figcaption>
                    <h3>${book.material[0].name}</h3>
                    <p>${book.material[0].materialDesc}</p>
                </figcaption>
              </div>
            `;
  });
  $(".book_select").html(bookHtml);
  clickBookEvent();
}

async function getFavBookById(id) {
  // check login and role
  const ifLogin = sessionStorage.getItem("accessToken") !== null;
  const role = sessionStorage.getItem("userRole")

  // get year edu subject
  const url = new URL(window.location.href);
  const year = url.searchParams.get('year');
  const edu = url.searchParams.get('edu');
  const subject = url.searchParams.get('subject');

  let materialInfo = await materialSvc.retrieveMaterial(id);
  materialInfo = materialInfo.data;
  // get suitable edu
  let suitableEduHTML = ``;
  if (materialInfo === null) materialInfo = [];
  materialInfo.suitableEdu.forEach((edu, index) => {
    // 最後一個不要有 、
    if (index === materialInfo.suitableEdu.length - 1) {
      suitableEduHTML = suitableEduHTML + `
      <strong>${edu}</strong>
    `
    } else {
      suitableEduHTML = suitableEduHTML + `
      <strong>${edu}</strong>、
    `
    }

  })

  // get book desc
  let bookDescHTML = ``;

  materialInfo.materialDesc.split(/\r?\n/).forEach((line) => {
    bookDescHTML = bookDescHTML + `
      <p>${line}</p>
    `
  })

  // get button
  let buttonHTML = ``;
  if (materialInfo.bookFunctions === null) materialInfo.bookFunctions = [];
  materialInfo.bookFunctions.forEach((button) => {
    let btnTmpHtml = "";
    try {
      const url = new URL(button.funUrl);
      // 非下載檔案
      if (!isDownloadUrl(url.href)) {
        btnTmpHtml = `<a class="buttonFun" href="${button.funUrl}" target="_blank"
                          data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}"
                          data-ga4-event="${button.funName}">
                          <button>${button.funName}</button>
                      </a>`;      } else {
        //下載檔案
        console.log("檔案下載");
        if (ifLogin){
          const hostname = new URL(button.funUrl).hostname;
          // 若為 aws 的資料 那麼會套用downloadWithDesireName
          if (hostname === "refbook-res.hle.com.tw"){
            btnTmpHtml = `<a class="buttonFun changeDownloadFile"
                            data-url="${button.funUrl}"
                            data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}"
                            data-ga4-event="${button.funName}">
                            <button>${button.funName}</button>
                          </a>`;
          } else {
            btnTmpHtml = `<a class="buttonFun"
                            href="${button.funUrl}"
                            data-url="${button.funUrl}"
                            data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}"
                            data-ga4-event="${button.funName}">
                            <button>${button.funName}</button>
                          </a>`;
          }
        } else {
          btnTmpHtml = `<a class="buttonFun"
                          href="#popup2"
                          data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}"
                          data-ga4-event="${button.funName}">
                          <button>${button.funName}</button>
                        </a>`;
        }
      }
    } catch (error) {
      btnTmpHtml = `<a class="buttonFun" href="#"><button>${button.funName}</button></a>`;
    }
    buttonHTML = buttonHTML + btnTmpHtml;
  });


  // get content image
  let contentHTML = ``;
  if (materialInfo.contentImgInfos === null) materialInfo.contentImgInfos = [];
  materialInfo.contentImgInfos.forEach((content) => {
    contentHTML = contentHTML + `
        <img src="${content.imgUrl}" alt="${materialInfo.name}" width="100%">
    `
  })

  // clear html
  $(".detaildesc_content").html(`
      <div class="detail_content">
        <div class="detail_book_img"></div>
        <div class="detail_book_desc"></div>
      </div>
      <div class="button_tag"></div>
      <div class="detail_book_desc_pic"></div>
  `);

  // cover image
  $(".detail_book_img").html(`
    <img src="${materialInfo.coverImgUrl}" alt="${materialInfo.name}" width="100%">
  `)

  // detail_book_desc
  const ebookDownloadUrl = ifLogin ? materialInfo.ebookDownload : '#popup2';
  const popId = ifLogin ? "#popup1" : "#popup2";


// 如果 ebookOpen, ebookDownload, ebookRead 是空的 or null 則不顯示按鈕
  let ebookOpenHtml = ``;
  if (materialInfo.ebookOpen !== null && materialInfo.ebookOpen.trim() !== ""){
    ebookOpenHtml = `<a class="ebookOpen" data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}" href="${popId}">
        <button class="active">開啟線上版電子書</button></a>`;
  }
  let ebookDownloadHtml = ``;
  if (materialInfo.ebookDownload !== null && materialInfo.ebookDownload.trim() !== ""){
    ebookDownloadHtml = `<a class="ebookDownload" data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}" href="${ebookDownloadUrl}"><button>下載電腦版電子書</button></a>`;
  }

  let ebookReadHtml = ``;
  if (materialInfo.ebookRead !== null && materialInfo.ebookRead.trim() !== ""){
    ebookReadHtml = `<a class="ebookRead" data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}" href="${materialInfo.ebookRead}" target="_blank"><button>立即試閱電子書</button></a>`
  }


  $(".detail_book_desc").html(`
     <h3>${materialInfo.name}</h3>
     <span>適用：${suitableEduHTML}
     <a class="favStatus" href="#" data-ga4-value="${edu}_${subject}_${year}_${materialInfo.name}"><em>加入最愛</em></a></span>
     <hr>
     <aside>${bookDescHTML}</aside>
     <div>
         ${ebookOpenHtml}
         ${ebookDownloadHtml}
         ${ebookReadHtml}
     </div>
  `);

  // 如果已經登入且身份是老師或補教 1. 則可以開啟電子書
  if (ifLogin && (role.includes("教師") || role.includes("補教") || role.includes("老師"))){
    // ebook modal title
    $("#ebookTitle").html(materialInfo.name);
    // 班級紀錄
    let ebookPopHTMLMiddle = "";
    let recordInfo = [];
    let userEmail = sessionStorage.getItem("userEmail");
    let idToken = sessionStorage.getItem("accessToken");
    let bookPath = materialInfo.ebookOpen;
    let bookId = "";
    if (bookPath !== null && bookPath !== ""){
      const urlArr = bookPath.split("/")
      const bookNo = urlArr[urlArr.length - 2];
      bookId = bookNo.split("_PC")[0];
    }
    let recordResp = null;
    try {
      recordResp = await eBookSvc.getClassRecord(userEmail, bookId);
      recordResp = JSON.parse(recordResp);

    }catch (e){
      console.log("無法獲得電子書訊息");
    }
    if (recordResp !== null) {
      recordInfo = recordResp.data.dataset;
    }
    if (recordInfo.length === 0 ){
      ebookPopHTMLMiddle += `
          <tr>
            <td colspan="4"><p style="color: #4d4d4d">無班級紀錄</p></td>
          </tr>
    `
    }else {
      for (const record of recordInfo) {
        if (record.file_ok){
          const ticks = record.ver;
          const date = new Date(ticks);
          const dateString = date.toLocaleString();
          const recordWebLink = await eBookSvc.getRecordEBookAmazon(bookPath, record.subject, userEmail, idToken);

          ebookPopHTMLMiddle += `
          <tr>
            <td>${record.subject}</td>
            <td data-content='時間'>${dateString}</td>
            <td data-content='功能'>
                <button class="deleteEbook" data-record="${record.subject}">刪除</button>
                <span></span>
                <a id="openEbookUrl-${record.subject}" target="_blank" href="${recordWebLink}"><button class="openEbook" data-record="${record.subject}">開啟</button></a>
            </td>
          </tr>
    `
        }
      }
    }

    $("#ebookSelect").html(ebookPopHTMLMiddle);

    // 當點選開啟線上版電子書時,
    // 開啟電子書的按鈕 與紀錄的開啟鈕 就會自動填入對應的 url
    $(".ebookOpen").click(async function (){
      // 新的電子書
      const newWbLink =  await eBookSvc.getRecordEBookAmazon(bookPath, null, userEmail, idToken);
      $("#openNewEBook").attr("href", newWbLink);
    })


    $(".deleteEbook").click(function (e){
      const subject = $(this).data("record");
      eBookSvc.deleteClassRecords(userEmail, bookId, subject);
      let parentTr = $(this).closest('tr');
      parentTr.remove();
    });


    $("#refreshRecord").click(async function (){
      let recordResp = await eBookSvc.getClassRecord(userEmail, bookId);
      recordResp = JSON.parse(recordResp);
      if (recordResp !== null) {
        recordInfo = recordResp.data.dataset;
      };

      let newHtml = "";
      for (const record of recordInfo) {
        if (record.file_ok){
          const ticks = record.ver;
          const date = new Date(ticks);
          const dateString = date.toLocaleString();
          const recordWebLink = await eBookSvc.getRecordEBookAmazon(bookPath, record.subject, userEmail, idToken)

          newHtml += `
          <tr>
            <td>${record.subject}</td>
            <td data-content='時間'>${dateString}</td>
            <td data-content='功能'>
                <button class="deleteEbook" data-record="${record.subject}">刪除</button>
                <span></span>
                <a id="openEbookUrl-${record.subject}" href="${recordWebLink}" target="_blank"><button class="openEbook" data-record="${record.subject}">開啟</button></a>
            </td>
          </tr>
    `
        }
      }
      $("#ebookSelect").html(newHtml);


      $(".deleteEbook")
        .off("click")
        .click(function (e){
          const subject = $(this).data("record");
          eBookSvc.deleteClassRecords(userEmail, bookId, subject);
          let parentTr = $(this).closest('tr');
          parentTr.remove();
        });
    })
  }



  // button_tag
  $(".button_tag").html(buttonHTML);
  // 檔案下載時會使用設定好的名字
  $(`a.buttonFun.changeDownloadFile`).click(function (){
    const funUrl =  $(this).data("url");
    const funName = $(this).data("name");
    if (funUrl !== null && funName !== null){
      const btnFileExt = funUrl.split(".").pop();
      const btnFileName = `${materialInfo.name}_${funName}.${btnFileExt}`;
      downloadWithDesireName(funUrl, btnFileName);
    }
  });


  // detail_book_desc_pic
  $(".detail_book_desc_pic").html(contentHTML);
}


async function addFavBook(){
  // 是否已經登入？
  if (sessionStorage.getItem("accessToken") !== null){
    const originUserFav = JSON.parse(sessionStorage.getItem("userFav"));
    // 該本書是否已經在  originUserFav?
    const ifFound = originUserFav.find((e) => {
      return e.materialId === sessionStorage.getItem("bookId");
    })
    if (ifFound === undefined){
      await favSvc.addFavoriteBook({
        email: sessionStorage.getItem("userEmail"),
        edu: sessionStorage.getItem("edu"),
        year: sessionStorage.getItem("year"),
        subject: sessionStorage.getItem("subject"),
        materialId: sessionStorage.getItem("bookId"),
      });
    }


    // 更新 sessionStorage 之 userFav
    let userFav = await favSvc.retrieveFavoriteBookByEmailEdu({
      email: sessionStorage.getItem("userEmail"),
      edu: sessionStorage.getItem("edu")
    });
    userFav = userFav.data;
    sessionStorage.setItem("userFav", JSON.stringify(userFav));

    // 更新畫面的我的最愛 變成移除最愛
    $(".favStatus")
      .html(`<em href="#">移除最愛</em>`)
      .off("click")
      .removeClass("addFavBook")
      .click(function (){
        removeFavBook();
      })

    removeFavToAdd();

  } else {
    // 記錄當前網址，使得登入完後直接回到該頁
    sessionStorage.setItem("previousURL", window.location.href);
  }
}

async function removeFavBook(){
  let bookId = sessionStorage.getItem("bookId");

  // 是否已經登入？
  if (sessionStorage.getItem("accessToken") !== null){
    let resp = await favSvc.deleteFavoriteBookByMaterialId(bookId);

    // 更新 sessionStorage 之 userFav
    let userFav = await favSvc.retrieveFavoriteBookByEmailEdu({
      email: sessionStorage.getItem("userEmail"),
      edu: sessionStorage.getItem("edu")
    });
    userFav = userFav.data;
    sessionStorage.setItem("userFav", JSON.stringify(userFav));

    // 更新畫面的我的最愛 變成加入最愛
    $(".favStatus")
      .off("click")
      .html(`<em href="#">加入最愛</em>`)
      .addClass("addFavBook")
      .click(function (){
        addFavBook();
      })

    addFavToRemove();


  } else {
    // 記錄當前網址，使得登入完後直接回到該頁
    sessionStorage.setItem("previousURL", window.location.href)
  }
}

function showFavStatus(){
  const userFav = sessionStorage.getItem("userFav");
  const ifLogin = sessionStorage.getItem("accessToken") !== null;
  const role = sessionStorage.getItem("userRole");

  // 已登入
  if (!ifLogin){
    $(".favStatus")
      .off("click")
      .html(`<em><a href="#popup2" style="display: block">加入最愛</a></em>`)
    addFavToRemove();

  } else {
    // 身份不合
    if (!role.includes("教師") && !role.includes("補教") && !role.includes("老師")){
      $(".favStatus")
        .off("click")
        .html(`<em><a href="#popup3" style="display: block">加入最愛</a></em>`)
      addFavToRemove();

    } else {
      const bookId = sessionStorage.getItem("bookId");
      const inFav = JSON.parse(userFav).find(obj => obj.materialId === bookId);

      // 但未收錄在我的最愛
      if (inFav === undefined) {

        $(".favStatus")
          .off("click")
          .html(`<em href="#">加入最愛</em>`)
          .addClass("addFavBook")
          .click(function () {
            addFavBook().then();
          });
        addFavToRemove();

        // 已在我的最愛
      } else {
        $(".favStatus")
          .off("click")
          .html(`<em href="#">移除最愛</em>`)
          .removeClass("addFavBook")
          .click(function () {
            removeFavBook().then()
          })
        removeFavToAdd();
      }
    }
  }
}

function addFavToRemove(){
  $(".detail_book_desc span em")
    .css({
      'background': 'url(../images/icon_nav_03.svg) no-repeat left center',
      'background-size': '19%',
      'color': '#2F2A67'
    })
    .mouseover(function (){
      $(".detail_book_desc span em").css({
        'background': 'url(../images/icon_favorite.svg) no-repeat left center',
        'background-size': '20%',
        'color': '#FF5653'
      })
    })
    .mouseleave(function (){
      $(".detail_book_desc span em").css({
        'background': 'url(../images/icon_nav_03.svg) no-repeat left center',
        'background-size': '19%',
        'color': '#2F2A67'
      })
    })
}

function removeFavToAdd(){
  $(".detail_book_desc span em")
    .css({
      'background': 'url(../images/icon_favorite.svg) no-repeat left center',
      'background-size': '20%',
      'color': '#FF5653'
    })
    .mouseover(function (){
      $(".detail_book_desc span em").css({
        'background': 'url(../images/icon_nav_03.svg) no-repeat left center',
        'background-size': '19%',
        'color': '#2F2A67'})
    })
    .mouseleave(function (){
      $(".detail_book_desc span em")
        .css({
          'background': 'url(../images/icon_favorite.svg) no-repeat left center',
          'background-size': '20%',
          'color': '#FF5653'
        })
    })
}
